import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { IPredictionAnswer } from "@framework/types";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { PredictionAnswerViewDialog } from "./view";
import { PredictionAnswerSearchForm } from "./search";

const PREDICTIONS_ANSWERS_URL = "/prediction/answers";
const PREDICTIONS_ANSWERS_DIALOG_KEY = "predictionAnswers";

export const PredictionAnswers = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IPredictionAnswer>
  >(PREDICTIONS_ANSWERS_URL, { enableInfiniteScroll: isMd });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IPredictionAnswer>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "prediction", "prediction.answers"]} />

      <PageHeader message="pages.prediction.answers.title" />

      <PredictionAnswerSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(answer => (
            <StyledListItem key={answer.id}>
              <List.ItemText sx={{ width: 0.2 }}>{answer.question.title}</List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>{answer.answer}</List.ItemText>
              <ListActions>
                <ListAction
                  message="form.tips.view"
                  icon={Visibility}
                  onClick={handleView(PREDICTIONS_ANSWERS_DIALOG_KEY, answer, "view")}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <PredictionAnswerViewDialog
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${PREDICTIONS_ANSWERS_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
